<template>
  <section class="home-bed">
    <div class="img-bed">
      <title-bar title="开卡激活" :showMore="barShowMore" :isShowMoreButton="true"></title-bar>
    </div>
    <bar-list :funcClicked="barListClicked" :show="showMoreList" :list="['操作说明','用户协议']"></bar-list>
    <div class="card-box">
      <img src="../assets/img/noAccess/img_card.png"
           alt="">
      <span>武汉通SIM交通卡</span>
    </div>
    <div class="word">
      <span>说明：</span>
      <span>1.手机具有NFC功能且可选择SIM卡通道</span>
      <span>2.需要使用移动的超级SIM卡（NFC-SIM卡）和放SIM1卡槽</span>
      <span>3.刷卡时，系统的NFC默认付款设置为SIM卡</span>
    </div>
    <p class="recharge">充值金额</p>
    <ul class="numList">
      <li v-for="(item,index) in numList"
          :key="index"
          @click="checkItem(index)"
          :class="checkIndex==index ?'checked':''">{{item}}<span v-if="index!=numList.length-1||!isNaN(numList[numList.length-1])">元</span></li>
    </ul>
    <ul class="payInfo">
      <li>
        <div class="key">支持范围</div>
        <div class="val">武汉市地铁/公交(武汉通一卡通支持城市圈)</div>
      </li>
      <li>
        <div class="key">乘车优惠</div>
        <div class="val">享武汉通实体卡同等折扣</div>
      </li>
      <li>
        <div class="key">优惠券</div>
        <div class="val">无</div>
      </li>
      <li>
        <div class="key">免服务费</div>
        <div class="val">0.00元</div>
      </li>
    </ul>
    <p class="pay">支付方式</p>
    <ul class="payType">
      <li v-for="(item,index) in payList"
          :key="index"
          @click="checkPay(index)">
        <div class="key">
          <img :src="item.img"
               alt="">
          <span>{{item.type}}</span>
        </div>
        <div class="val"
             v-if="payIndex!=index"></div>
        <img src="../assets/img/noAccess/icon_check.png"
             alt=""
             v-else
             class="checked">
      </li>
    </ul>
    <div class="user">
      <div class="icon"
           @click="readMe()"
           v-if="!ifRead"></div>
      <div class="icon read"
           v-else
           @click="readMe()">
        <img src="../assets/img/noAccess/duihao.png"
             alt="">
      </div>
      我已阅读并同意
      <span @click="goProtocol" style="color:#4A8EF7">《武汉通SIM交通卡用户协议》</span>
    </div>
    <div class="btn"
         @click="goRouter('writingOpen')">激活并支付{{numList[checkIndex]}}元</div>
    <sure-info :isShow="isShow_add"
               title='自定义充值金额'
               content=""
               @isShow='isShow'>
      <div>
        <input v-model="value"
               placeholder="请输入充值金额..." />
        <span>*充值金额必须为1000元之内的整数</span>
        <div class="sure-btn"
             @click="addNum()">确认</div>
      </div>
    </sure-info>
  </section>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import icon_wx from "@/assets/img/noAccess/icon_wx.png"
import icon_zfb from "@/assets/img/noAccess/icon_zfb.png"
import { Checkbox, CheckboxGroup } from 'vant';
import SureInfo from '../components/SureInfo.vue'
import barList from '../components/barList.vue'
export default {
  name: 'openCard',
  data () {
    return {
      loading: true,
      numList: [
        "10", "50", "100", "200", "300", '自定义',
      ],
      payList: [
        {
          img: icon_wx,
          type: "微信支付"
        },
        {
          img: icon_zfb,
          type: "支付宝"
        }
      ],
      checkIndex: 0,
      payIndex: 0,
      checked: true,
      isShow_add: false,
      value: "",
      ifRead: false,
      showMoreList: false,//右上角菜单是否显示
    }
  },
  components: {
    TitleBar, SureInfo, barList
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    barListClicked (index) {
      console.log('index===',index)
      this.showMoreList = false
      if (index == 0) {
        this.$router.push({
          name: 'useWord'
      })
      }else if (index == 1) {
        this.$router.push({
          name: 'protocol'
      })
      }
    },
    barShowMore () {
      this.showMoreList = !this.showMoreList
    },
    readMe () {
      this.ifRead = !this.ifRead
    },
    ifNum (value) {
      var rg = /^[0-9]*[1-9][0-9]*$/;
      return rg.test(value);
    },
    addNum () {
      if (this.value) {
        if (this.numList.indexOf(this.value) == -1) {
          if (this.value < 1000 && this.ifNum(this.value)) {
            this.numList.pop();
            this.numList.push(this.value);
            this.isShow_add = false;
          } else {
            this.$eventBus.$emit('getTipsInfo', {
              msg: "请输入1000内整数"
            })
          }

        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: "请勿输入已有金额"
          })
        }
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: "请输入自定义金额"
        })

      }

    },
    isShow () {
      this.isShow_add = false
    },
    checkItem (index) {
      this.checkIndex = index;
      if (this.checkIndex == 5) {
        this.isShow_add = true
      } else {
        this.isShow_add = false
      }
    },
    checkPay (index) {
      this.payIndex = index;
    },
    goProtocol() {
      this.$router.push({
          name: 'protocol'
      })
    },
    goRouter (router) {

      if (!this.ifRead) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请先阅读并同意《武汉通SIM交通卡用户协议》'
        })
        return
      }

      if (this.loading) {
        this.$router.push({
          name: router,
          params: {
            payList: this.payList,
            payIndex: this.payIndex,
            numList: this.numList,
            checkIndex: this.checkIndex
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  padding-bottom: 400px;
  overflow: scroll;
  position: relative;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  height: 320px;
  background-image: url(../assets/img/noAccess/img_top.png);
  background-repeat: no-repeat;
  background-size: cover;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.card-box {
  width: 92%;
  position: absolute;
  top: 110px;
  margin-left: 4%;
  img {
    width: 100%;
  }
  span {
    position: absolute;
    left: 42px;
    top: 40%;
    font-size: 40px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9019607843137255);
  }
}

.word {
  width: 92%;
  position: absolute;
  top: 460px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  span {
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
  }
}
.recharge {
  width: 92%;
  position: absolute;
  top: 610px;
  margin-left: 4%;
  font-size: 30px;
  font-weight: 500;
  color: #282b29;
  margin-top: 40px;
}
.numList {
  width: 92%;
  position: absolute;
  top: 704px;
  margin-left: 4%;
  display: flex;
  // flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  li {
    width: 30%;
    height: 88px;
    line-height: 88px;
    text-align: center;
    // background: #4a8ef7;
    border: 1px solid #dcdcdc;
    border-radius: 16px 16px 16px 16px;
    margin-top: 34px;
    font-size: 30px;
    font-weight: 400;
    color: #333333;
  }
  .checked {
    background-color: #4a8ef7;
    color: #ffffff;
  }
}
.payInfo {
  width: 92%;
  position: absolute;
  top: 984px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px dashed #999999;
  li {
    width: 100%;
    height: 37px;
    line-height: 37px;
    display: flex;
    font-size: 26px;
    margin-bottom: 24px;
    .key {
      width: 150px;
      color: #282b29;
      font-weight: 500;
    }
    .val {
      width: calc(100% - 150px);
      font-weight: 400;
      color: #666666;
      text-align: right;

      // display: flex;
      // justify-content: flex-end;
    }
  }
}
.pay {
  width: 92%;
  position: absolute;
  top: 1224px;
  margin-left: 4%;
  font-size: 30px;
  font-weight: 500;
  color: #282b29;
  margin-top: 40px;
}
.payType {
  width: 92%;
  position: absolute;
  top: 1328px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  align-items: center;
  li {
    width: 100%;
    height: 40px;
    margin-bottom: 32px;
    display: flex;
    .key {
      width: calc(100% - 40px);
      display: flex;
      img {
        width: 40px;
        height: 40px;
        margin-right: 24px;
      }
    }
    .val {
      width: 38px;
      height: 38px;
      border: 1px solid #999999;
      border-radius: 50%;
      margin-left: 1px;
    }
    .checked {
      width: 40px;
      height: 40px;
    }
  }
}
.user {
  width: 92%;
  position: absolute;
  top: 1328px;
  margin-left: 4%;
  height: 33px;
  margin-top: 196px;
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  display: flex;
  align-items: center;
  .icon {
    width: 23px;
    height: 23px;
    border: 1px solid #999999;
    border-radius: 10px;
    margin-right: 16px;
  }
  .read {
    width: 23px;
    height: 23px;
    border: 1px solid #4a8ef7;
    background: #4a8ef7;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 10px;
    }
  }
}
.btn {
  width: 92%;
  position: absolute;
  top: 1568px;
  margin-left: 4%;
  height: 98px;
  line-height: 98px;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  font-size: 32px;
  font-family: 宋体;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-bottom: 50px;
}
</style>
